import {useNavigate} from "@tanstack/react-router";
import {useCallback} from "react";
import {useCartContext} from "@/components/Providers/CartProvider.tsx";
import {useUser} from "@/components/Providers/JWTProvider.tsx";
import useConfirmFab from "@/hooks/useConfirmFab.tsx";
import {closeFMWindow} from "@/utils/fmScripts.ts";

const useHandleFabSubmit = () => {
    const {cart, refreshCart, cartPaymentSuccess} = useCartContext();
    const {isEmployee} = useUser();
    const confirmFab = useConfirmFab();
    const navigate = useNavigate();

    return useCallback(
        async (payNowAmount: number) => {
            if (cart?.cartItems.length && cart.cartItems.length > 0) {
                const confirmResponse = await confirmFab([], cart.id);
                if (confirmResponse?.ok) {
                    const responseJson = await confirmResponse.json();
                    if (responseJson) {
                        let hasFees = false;
                        if (cart.cartItems.find(i => i.feeId !== undefined) !== undefined) {
                            hasFees = true;
                        }

                        await refreshCart();
                        if (payNowAmount > 0) {
                            await cartPaymentSuccess(
                                `FAB payment of $${payNowAmount.toString()} submitted.`,
                            );
                        } else {
                            await cartPaymentSuccess("Free payment submitted.");
                        }

                        closeFMWindow();

                        await navigate({
                            to: isEmployee
                                ? "/instructor/fees"
                                : hasFees
                                  ? "/fees"
                                  : "/my-registrations",
                            search: {purchased: "purchased"},
                        });
                    }
                }
            }
        },
        [cart, refreshCart, cartPaymentSuccess, confirmFab, navigate, isEmployee],
    );
};

export default useHandleFabSubmit;